import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { modulByRol } from '@pages/modules-permission/interfaces/modulByRol';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};


@Injectable({
  providedIn: 'root'
})
export class ModulosService {
  private _url = environment.apiBaseUrl + 'api/GetModuleByRol';
  constructor(private _http: HttpClient) {}

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  readOne(moduleName: string): Observable<Response> {
    let url: string = this._url + moduleName ;
    return this._http.get<Response>(url);
  }

  create(model: modulByRol): Observable<Response> {
    let url: string = this._url + '/Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }

  update(model: modulByRol): Observable<Response> {
    let url: string = this._url + '/Update' ;
    return this._http.put<Response>(url, model, httpOption);
  }

  delete(model: modulByRol): Observable<Response> {
    let url: string = this._url + '/Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }
  SpGetMenu(id : number): Observable<Response> {
    let url: string = this._url + "/SpGetMenu/" + id ;
    return this._http.get<Response>(url);
  }
  SpGetSubMenusByRolID(UserEmail : string ,moduloId): Observable<Response> {
    let url: string = this._url + "/SpGetSubMenusByRolID/" + UserEmail + "/" + moduloId ;
    return this._http.get<Response>(url);
  }
}
